import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const ST = { new: "text-[#FFB800] border-[#FFB800]/50", accepted: "text-[#00F5D4] border-[#00F5D4]/50", declined: "text-slate-500 border-white/15" };

export const Bookings = () => {
  const [list, setList] = useState(null);
  const load = () => api.get("/me/bookings").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const set = async (id, status) => { await api.post(`/me/bookings/${id}/status`, { status }); toast.success(`Marked as ${status}`); load(); };
  if (!list) return null;
  return (
    <div className="space-y-4" data-testid="dash-bookings">
      <p className="text-sm text-slate-400">Venues and organizers can request you from your artist page. Reply to them directly by email.</p>
      {list.map((b) => (
        <div key={b.id} className="panel p-5" data-testid={`booking-${b.id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <div className="font-display text-lg font-bold">{b.name}{b.organization && <span className="text-slate-400"> · {b.organization}</span>}</div>
              <div className="font-mono text-xs uppercase text-slate-500">{[b.city, b.event_date && `event ${b.event_date}`, b.budget && `budget ${b.budget}`].filter(Boolean).join(" · ")} · received {fmtDate(b.created_at)}</div>
            </div>
            <span className={`rounded-full border px-3 py-0.5 font-mono text-[10px] uppercase ${ST[b.status]}`}>{b.status}</span>
          </div>
          <p className="mt-3 whitespace-pre-line text-slate-300">{b.message}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <a href={`mailto:${b.email}?subject=${encodeURIComponent("Booking request via Fuorionda")}`} className="btn-hot !px-4 !py-2 text-xs" data-testid={`booking-reply-${b.id}`}><Mail className="h-4 w-4" />Reply ({b.email})</a>
            {b.status !== "accepted" && <button className="btn-ghost !px-4 !py-2 text-xs" onClick={() => set(b.id, "accepted")} data-testid={`booking-accept-${b.id}`}>Accept</button>}
            {b.status !== "declined" && <button className="btn-ghost !px-4 !py-2 text-xs" onClick={() => set(b.id, "declined")} data-testid={`booking-decline-${b.id}`}>Decline</button>}
          </div>
        </div>
      ))}
      {!list.length && <p className="py-10 text-center text-slate-500" data-testid="no-bookings">No booking requests yet. Share your artist page with venues and promoters.</p>}
    </div>
  );
};
